import {BaseOptionsProps} from '../typings';
import {ListProps} from './typings';

export const subjectOptions: BaseOptionsProps[] = [
  {
    label: 'abstract & conceptual',
    value: 'abstract-conceptual',
  },
  {
    label: 'animals & birds',
    value: 'animals-birds',
  },
  {
    label: 'architecture & cities',
    value: 'architecture-cityscapes',
  },
  {
    label: 'cars, bikes & transport',
    value: 'transportation-maps',
  },
  {
    label: 'flowers & plants',
    value: 'flowers-plants',
  },
  {
    label: 'landscapes, sea & sky',
    value: 'landscapes-sea-sky',
  },
  {
    label: 'nudes & erotic',
    value: 'nudes-erotic',
  },
  {
    label: 'portraits & people',
    value: 'people-portraits',
  },
  {
    label: 'still life',
    value: 'still-life',
  },
];

export const subjectFilterList: Readonly<ListProps> = {
  type: 'radio',
  style: 'text',
  options: [
    {
      label: 'all art',
      value: 'all',
    },
    ...subjectOptions.map((subject) => ({
      label: subject.label,
      value: subject.value,
    })),
  ],
};
